<div class="n-oldalfej">
  <div>
    <h2>{{ nezet === 'osszesito' ? 'Éves összesítő' : (nezet === 'atutalas' ? 'Átutalás' : 'Havi bérlista') }}</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }}</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto" *ngIf="nezet !== 'osszesito'">Hónap
    <select [ngModel]="aktiv.ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button (click)="berfeladas()" [disabled]="!aktiv.ugyfelId" title="Bruttó bér + közterhek feladása a NAPLO-ba">
    <ion-icon slot="start" name="git-network-outline"></ion-icon>Bérfeladás NAPLO-ba
  </ion-button>
</div>

<div class="b-fulek">
  <button *ngFor="let f of fulek" type="button" [class.aktiv]="nezet === f.k" (click)="nezetValt(f.k)">{{ f.c }}</button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<!-- Havi bérlista -->
<div class="n-szuro-sor" *ngIf="aktiv.ugyfelId && nezet === 'berlista'">
  <button type="button" class="ov-gomb" (click)="nyomtatBerlista()" [disabled]="!berlista.sorok.length" title="A bérlista és a fizetendő közterhek (hova mit kell utalni)">
    <ion-icon name="print-outline"></ion-icon>Bérlista nyomtatása</button>
  <button type="button" class="ov-gomb" (click)="nyomtatAtveteli()" [disabled]="!berlista.sorok.length" title="Átvételi lista: a munkavállalók aláírásával, az összegekkel">
    <ion-icon name="create-outline"></ion-icon>Átvételi lista (aláírással)</button>
</div>
<div class="tabla-wrap" *ngIf="aktiv.ugyfelId && nezet === 'berlista'">
  <table class="n-racs">
    <thead><tr>
      <th>Alkalmazott</th><th>Adóazonosító</th>
      <th class="num">Bruttó</th><th class="num">SZJA</th><th class="num">TB</th><th class="num" *ngIf="berlista.osszesen.ekho">EKHO</th>
      <th class="num" title="Letiltás, pénztártagdíj és egyéb levonás">Letiltás, egyéb</th><th class="num">Nettó</th><th class="num">{{ aktiv.kivas ? 'KIVA' : 'Szocho' }}</th><th class="num">Összköltség</th>
    </tr></thead>
    <tbody>
      <tr *ngFor="let r of berlista.sorok">
        <td>{{ r.alkalmazott_nev }}
          <span class="cimke sarga" *ngIf="r.tipus === 'hokozi'" [title]="'Hóközi kifizetés' + (r.kifizetes ? ' – ' + r.kifizetes : '')">{{ r.megnevezes || 'hóközi' }}</span>
        </td><td>{{ r.adoazonosito || '—' }}</td>
        <td class="num">{{ r.brutto | number:'1.0-0' }}</td>
        <td class="num">{{ r.szja | number:'1.0-0' }}</td>
        <td class="num">{{ r.tb_jarulek | number:'1.0-0' }}</td>
        <td class="num" *ngIf="berlista.osszesen.ekho">{{ r.ekho | number:'1.0-0' }}</td>
        <td class="num">{{ (r.letiltas || 0) + (r.egyeb_levonas || 0) | number:'1.0-0' }}</td>
        <td class="num cs-penz"><b>{{ r.netto | number:'1.0-0' }}</b></td>
        <td class="num">{{ r.szocho | number:'1.0-0' }}</td>
        <td class="num">{{ r.koltseg | number:'1.0-0' }}</td>
      </tr>
    </tbody>
    <tfoot><tr>
      <td colspan="2">Összesen</td>
      <td class="num">{{ berlista.osszesen.brutto | number:'1.0-0' }}</td>
      <td class="num">{{ berlista.osszesen.szja | number:'1.0-0' }}</td>
      <td class="num">{{ berlista.osszesen.tb | number:'1.0-0' }}</td>
      <td class="num" *ngIf="berlista.osszesen.ekho">{{ berlista.osszesen.ekho | number:'1.0-0' }}</td>
      <td class="num">{{ (berlista.osszesen.letiltas || 0) + (berlista.osszesen.egyeb_levonas || 0) | number:'1.0-0' }}</td>
      <td class="num">{{ berlista.osszesen.netto | number:'1.0-0' }}</td>
      <td class="num">{{ berlista.osszesen.szocho | number:'1.0-0' }}</td>
      <td class="num">{{ berlista.osszesen.koltseg | number:'1.0-0' }}</td>
    </tr></tfoot>
  </table>
  <div class="ures" *ngIf="!berlista.sorok.length"><ion-icon name="document"></ion-icon>Nincs számfejtés ebben a hónapban.</div>
</div>

<!-- A hónap közterhei: mit kell utalni és hova (NAV beszedési számlák adónemenként) -->
<div class="n-panel b-kozteher" *ngIf="aktiv.ugyfelId && nezet === 'berlista' && berlista.kozterhek?.tetelek?.length">
  <div class="n-panel-cim">Fizetendő közterhek és utalások <span class="n-alcim">· a NAV-nak összesen <b>{{ berlista.kozterhek.nav_osszesen | number:'1.0-0' }} Ft</b>, esedékes {{ berlista.kozterhek.esedekes | date:'yyyy. MM. dd.' }}</span></div>
  <div class="tabla-wrap">
    <table class="n-racs">
      <thead><tr><th>Mit</th><th>Kinek</th><th>Számlaszám</th><th>Esedékes</th><th class="num">Összeg</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let t of berlista.kozterhek.tetelek">
          <td><b>{{ t.megnevezes }}</b><div class="b-kt-megj" *ngIf="t.csoport === 'nav' && t.megjegyzes">{{ t.megjegyzes }}</div></td>
          <td>{{ t.kedvezmenyezett }}</td>
          <td><ng-container *ngIf="t.szamla; else nincsSzla"><span class="b-kt-szla">{{ t.szamla }}</span><span class="n-alcim" *ngIf="t.adonem"> · adónem {{ t.adonem }}</span></ng-container>
            <ng-template #nincsSzla><span class="n-alcim">{{ t.megjegyzes }}</span></ng-template></td>
          <td>{{ t.esedekes ? (t.esedekes | date:'yyyy. MM. dd.') : '' }}</td>
          <td class="num"><b>{{ t.osszeg | number:'1.0-0' }}</b></td>
          <td><button type="button" class="kv-mini" *ngIf="t.szamla" title="Számlaszám másolása" (click)="masol(t.szamla)"><ion-icon name="copy-outline"></ion-icon></button></td>
        </tr>
      </tbody>
      <tfoot><tr><td colspan="4">A NAV-nak összesen</td><td class="num">{{ berlista.kozterhek.nav_osszesen | number:'1.0-0' }}</td><td></td></tr></tfoot>
    </table>
  </div>
  <p class="b-kt-megj">A NAV-ra utalt összeg adónemenként a dolgozónként forintra kerekített közterhek összege (egyezik a 08-as bevallással); a közleménybe az adószám kerül.
    Számlaszámok: NAV adóztatási számlaszámok (2026. 11. 01-jétől).</p>
</div>

<!-- Éves összesítő -->
<div class="tabla-wrap" *ngIf="aktiv.ugyfelId && nezet === 'osszesito'">
  <table class="n-racs">
    <thead><tr><th>Alkalmazott</th>
      <th class="num">Bruttó (év)</th><th class="num">SZJA (év)</th><th class="num">TB (év)</th><th class="num">Nettó (év)</th><th class="num">{{ aktiv.kivas ? 'KIVA' : 'Szocho' }} (év)</th>
    </tr></thead>
    <tbody>
      <tr *ngFor="let a of alkalmazottakOsszesito">
        <td>{{ a.nev }}</td>
        <td class="num">{{ alkEves(a.id, 'brutto') | number:'1.0-0' }}</td>
        <td class="num">{{ alkEves(a.id, 'szja') | number:'1.0-0' }}</td>
        <td class="num">{{ alkEves(a.id, 'tb') | number:'1.0-0' }}</td>
        <td class="num"><b>{{ alkEves(a.id, 'netto') | number:'1.0-0' }}</b></td>
        <td class="num">{{ alkEves(a.id, 'szocho') | number:'1.0-0' }}</td>
      </tr>
    </tbody>
  </table>
  <div class="ures" *ngIf="!osszesito.length"><ion-icon name="document"></ion-icon>Nincs adat erre az évre.</div>
</div>

<!-- Átutalási lista -->
<div *ngIf="aktiv.ugyfelId && nezet === 'atutalas'">
  <div class="n-szuro-sor">
    <button type="button" class="ov-gomb" (click)="atutalasExport()" [disabled]="!atutalas.sorok.length"><ion-icon name="download-outline"></ion-icon>CSV export</button>
    <span class="spacer"></span>
    <span>Összesen: <b>{{ atutalas.osszeg | number:'1.0-0' }} Ft</b></span>
  </div>
  <div class="tabla-wrap">
    <table class="n-racs">
      <thead><tr><th>Alkalmazott</th><th>Bankszámlaszám</th><th class="num">Nettó</th></tr></thead>
      <tbody>
        <tr *ngFor="let r of atutalas.sorok">
          <td>{{ r.alkalmazott_nev }}
            <span class="cimke sarga" *ngIf="r.tipus === 'hokozi'" [title]="'Hóközi kifizetés' + (r.kifizetes ? ' – ' + r.kifizetes : '')">{{ r.megnevezes || 'hóközi' }}</span>
          </td><td>{{ r.bankszamla || '— nincs számla —' }}</td>
          <td class="num">{{ r.netto | number:'1.0-0' }}</td>
        </tr>
      </tbody>
      <tfoot><tr><td colspan="2">Összesen</td><td class="num">{{ atutalas.osszeg | number:'1.0-0' }}</td></tr></tfoot>
    </table>
    <div class="ures" *ngIf="!atutalas.sorok.length"><ion-icon name="card"></ion-icon>Nincs kifizetendő nettó ebben a hónapban.</div>
  </div>
  <!-- Banki átutalási csomag: a nettó bérek Electra .HUF állományban (backend/ber-electra.js) -->
  <app-ber-electra-panel fajta="ber"></app-ber-electra-panel>
</div>
